module.exports = __webpack_public_path__ + "static/img/string_bg.83049c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img2/string_bg.png
// module id = v4Hg
// module chunks = 1